require('./footer/accordion.js');
require('./footer/matrix.js');
require('./footer/material.js');
require('./footer/totop.js');

(function($) {
    if ($(window).width() <= 500) {
        var h = $('#site-header').outerHeight();
        $('.header__menu').css('top', h + 'px');
        $('.header__menu').css('padding-bottom', h + 'px');
    }
})(jQuery);